import React, {Component} from 'react';
import * as d3 from "d3";
import {select} from "d3-selection";
import PropTypes from "prop-types";
import LegendWarmingStripes from "./legendWarmingStripes.jsx";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import "./warmingStripesPlot.scss";

class Warmingstripesplot extends Component {
  constructor(props) {
    super(props);

    const {graphData} = this.props;

    this.createChart = this.createChart.bind(this);
    this.placeholderChart = React.createRef();
    this.placeholderWrapper = React.createRef();
    this.svg = d3.select('.svg');
    this.graphData = graphData;
    this.colorScaleLimits = [-2.4, -2.1, -1.8, -1.5, -1.2, -0.9, -0.6, -0.3, 0.0, 0.3, 0.6, 0.9, 1.2, 1.5, 1.8, 2.1, 2.4];
    this.colorScaleColours = [
      "#08306b",
      "#08519c",
      "#2171b5",
      "#4292c6",
      "#6baed6",
      "#9ecae1",
      "#c6dbef",
      "#deebf7",
      "#fee0d2",
      "#fcbba1",
      "#fc9272",
      "#fb6a4a",
      "#ef3b2c",
      "#cb181d",
      "#a50f15",
      "#67000d",
    ];
    this.chartSize = {
      "width": "100%",
      "height": 250
    }
    this.startYear = graphData[0]?.year;
    this.endYear = graphData[this.graphData.length - 1]?.year;
  }

  componentDidMount() {
    this.createChart(
      this.graphData
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {graphData} = this.props;

    this.createChart(
      graphData
    );
  }

  createChart(graphData) {
    // TODO: Remove additional colors at top and bottom - currently needed to get correct color values from thresholds
    const colors = ["#08306b","#08306b"].concat(this.colorScaleColours).concat(["#67000d"])
    const limits = [-2.7].concat(this.colorScaleLimits).concat([2.7])
    const svgWrapper = select(this.placeholderChart.current);
    const stripeWidth = 100 / graphData.length;
    const stripeHeight = "250px";
    const mapToColour = d3
      .scaleThreshold()
      .domain(limits)
      .range(colors);

    svgWrapper.selectAll('rect').remove();

    svgWrapper
      .attr("height", stripeHeight)
      .attr("width", "100%")
      .selectAll("rect")
      .data(graphData)
      .enter()
      .append("rect")
      .attr("height", stripeHeight)
      .attr("width", stripeWidth + "%")
      .attr("y", 0)
      .attr("x", (data, index) => index * stripeWidth + "%")
      .style("fill", data => mapToColour(data.referenceValue))
      .style('shape-rendering', 'crispedges')
      .attr("class", "tippy")
      .attr("data-year", data => data.year)
      .attr("data-absolute-value", data => data.absoluteValue)
      .attr("data-reference-value", data => data.referenceValue);

    tippy('.tippy',
      {
        content: (element) => {
          return `<div class="section">
                       <span class="highlight">${element.dataset.year}</span>
                  </div>
                  <div class="section">
                      Jahresmittelwert<br>
                      <span class="highlight">${parseFloat(element.dataset.absoluteValue).toFixed(2).replace(".", ",")}</span>
                  </div>
                  <div class="section">
                      Abweichung von der Referenzperiode 1971-2000<br>
                      <span class="pill">${parseFloat(element.dataset.referenceValue).toFixed(2).replace(".", ",")}</span>
                  </div>`;
        },
        appendTo: document.querySelector('.warmingstripes'),
        allowHTML: true,
        duration: 0
      });
  }

  render() {
    const {chartTitle, chartSubtitle} = this.props;
    const currentYear = new Date().getFullYear();

    return (
      <div className="warmingstripes">
        <div
          ref={this.placeholderWrapper}
          className='wrapper'
        >
          <h3 className="chart-title">{chartTitle}</h3>
          <h5 className="chart-subtitle">{chartSubtitle}</h5>
          <LegendWarmingStripes limits={this.colorScaleLimits} colours={this.colorScaleColours}/>
          <div className="svg-wrapper">
            <svg
              className="svg"
              ref={this.placeholderChart}
              width={this.chartSize.width}
              height={this.chartSize.height}
            />
            <div className="labelingAxisX">
              <span>{this.startYear}</span>
              <span>{this.endYear}</span>
            </div>
          </div>
          <div className="source">
            © Bayerisches Klimainformationssystem LfU {currentYear}, basierend auf Deutscher Wetterdienst (Climate Data Center)
          </div>
        </div>
      </div>
    );
  }
}

Warmingstripesplot.propTypes = {
  graphData: PropTypes.array,
  chartTitle: PropTypes.string,
  chartSubtitle: PropTypes.string,
};

Warmingstripesplot.defaultProps = {
  graphData: [{}],
  chartTitle: '',
  chartSubtitle: '',
};

export default Warmingstripesplot;
